import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'warning-template',
	templateUrl: './warning-template.component.html',
	styleUrls: ['./warning-template.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CommonModule],
})
export class WarningTemplateComponent {}
